import Platform from "@/config/platform";
import { ApiNetWork } from "@/network/apiNet/apiNet";
import { Storage } from "@/uitls/Storage";

export function getServerConfig() {
  let data: any = {
    client: Platform.client,
  }
  const standalone = Platform.standalone;
  if (standalone) {
    data.client = "ios";
  }
  // customerId
  // const customerId = Storage.get("customerId");
  // if (customerId && customerId != '') {
  //   data.check_id = customerId;
  //   data.check_type = 2;
  // }else{
  //   // identifier
  //   const  identifier = Storage.get("identifier")
  //   console.log('是游客',identifier);

  //   data.check_id = identifier;
  //   data.check_type = 1;
  // }

  return ApiNetWork.get("app/encryptionServerConfig", data);
}

//这里面有app下载地址
export function encryptionConfig() {
  return ApiNetWork.get("app/encryptionConfig");
}

export function getMsgShield() {
  return ApiNetWork.get("app/encryptionMsgShield");
}

export function getServerTime() {
  return ApiNetWork.get("app/encryptionTime");
}

// 测试签名
export function testSign() {
  return ApiNetWork.get('app/verifySign');
}